export function formatTimeAgo(days: number): string {
  const timeUnits = [
    { unit: 'year', days: 365 },
    { unit: 'month', days: 30 },
    { unit: 'day', days: 1 },
  ]

  for (const { unit, days: unitDays } of timeUnits) {
    if (days >= unitDays) {
      const count = Math.floor(days / unitDays)
      return `${count} ${unit}${count > 1 ? 's' : ''} ago`
    }
  }

  return 'today'
}
